import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { deleteDocument } from "../../../firebase/utility";
import { fetchReturnOrdersUtil } from "../../../utility";
const useReturnOrders = () => {
    const dispatch = useDispatch()
    const { all_return_orders } = useSelector((state) => state.redux);
    const [searchValue, setSearchValue] = useState("");
    const [selectedOrderStatus, setSelectedOrderStatus] = useState(
        "Select Return Order Status"
    );
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const gettingReturnOrders = () => {
        if (selectedOrderStatus === "Select Return Order Status") {
            setSelectedOrderStatus("")
        }
        fetchReturnOrdersUtil({
            page,
            search: searchValue ?? "",
            pageSize,
            selectedOrderStatus,
            setLoading,
            dispatch,
            setTotalPages,
        });
    }
    const handleDelete = (id) => {
        if (id) {
            deleteDocument("ReturnOrders", id).then((res) => {
                toast.success("Return Order Deleted Successfully");
                gettingReturnOrders();
            });
        }
    };
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            gettingReturnOrders()
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [page, searchValue, selectedOrderStatus, pageSize]);
    useEffect(() => {
        const savedSearch = localStorage.getItem('returnOrderSearch');
        const savedStatus = localStorage.getItem('selectedReturnOrderStatus');
        if (savedSearch) {
            setSearchValue(savedSearch);
        }
        if (savedStatus) {
            setSelectedOrderStatus(savedStatus);
        }
    }, []);
    return {
        page,
        setPage,
        pageSize,
        setPageSize,
        loading,
        totalPages,
        selectedOrderStatus,
        setSearchValue,
        searchValue,
        orders: all_return_orders || [],
        handleDelete,
        setSelectedOrderStatus
    };
};
export default useReturnOrders;
